// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"944cb7e8","377":"748f6986"}[chunkId] + ".chunk.js";
};